import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/home.css';

const slides = [
  { src: '/images/Slide.jpg' },
  { src: '/images/Slide1.jpg' },
  { src: '/images/Slide2.jpg' },
  { src: '/images/Slide3.jpg' },
  { src: '/images/Slide4.jpg' },
];

const leftServices = [
  { icon: '📊', title: 'Data Processing and Confirmation',  desc: 'Organisations across the globe are working on projects and interventions aimed at achieving specific goals.' },
  { icon: '💵', title: 'Welcome Pitch',                     desc: 'The key to survive and succeed in a competitive environment is to know more and do better than the competition.' },
  { icon: '🗄️', title: 'Database Applications',             desc: 'Data is critical to an organization will be an understatement. By understanding how operational processes are linked to data.' },
  { icon: '📱', title: 'Market and Feedback Research',      desc: 'The world of mobile technologies has been evolving to now have a universal platform and familiar interface across.' },
  { icon: '📈', title: 'Analytics and Concept',             desc: 'The world of mobile technologies has been evolving to now have a universal platform and familiar interface across.' },
];

const rightServices = [
  { icon: '📚', title: 'Product Features Awareness and Promotion', desc: 'With the rapid rise of cutting-edge technologies and the increasing focus on competitive advantage and quality.' },
  { icon: '🏆', title: 'Resolution of Customers Issues',           desc: 'Avalon offers a wide range of innovative open source solutions including consulting and training services based.' },
  { icon: '✅', title: 'Quality Assurance',                        desc: 'Delivering a reliable software application is not a one-time process. The real challenge lies in delivering a quality application.' },
  { icon: '📣', title: 'Communications & Branding',                desc: 'Our creative team has global experience and enjoys addressing challenges of creating and managing brand identities.' },
  { icon: '🔗', title: 'Communications & Flow',                    desc: 'Our creative team has global experience and enjoys addressing challenges of creating and managing brand identities.' },
];

/* ── ALL 18 CLIENT LOGOS ── */
const techStack = [
  { src: '/images/clients/vodafone1.png',  alt: 'Vodafone' },
  { src: '/images/clients/aircel1.png',    alt: 'Aircel' },
  { src: '/images/clients/airtel1.png',    alt: 'Airtel' },
  { src: '/images/clients/bajaj1.png',     alt: 'Bajaj Allianz' },
  { src: '/images/clients/boii.png',       alt: 'Bank of India' },
  { src: '/images/clients/cbbi.png',       alt: 'Central Bank of India' },
  { src: '/images/clients/cscc.png',       alt: 'CSC' },
  { src: '/images/clients/den1.png',       alt: 'DEN Boom Band' },
  { src: '/images/clients/hdfc1.png',      alt: 'HDFC Bank' },
  { src: '/images/clients/icici1.png',     alt: 'ICICI Bank' },
  { src: '/images/clients/maxlogo1.jpg',   alt: 'Max Bupa' },
  { src: '/images/clients/Mobiquick1.png', alt: 'MobiKwik' },
  { src: '/images/clients/paytm1.png',     alt: 'Paytm' },
  { src: '/images/clients/pb.png',         alt: 'PNB' },
  { src: '/images/clients/psbb.png',       alt: 'PSB' },
  { src: '/images/clients/Rbl.png',        alt: 'RBL Bank' },
  { src: '/images/clients/sbilogo1.png',   alt: 'SBI Card' },
  { src: '/images/clients/testlogo.jpg',   alt: 'Max Healthcare' },
];

const facts = [
  { icon: '📅', value: '14+',   label: 'Years of experience' },
  { icon: '📍', value: '24',    label: 'Branches In All India' },
  { icon: '🖥️', value: '14+',   label: 'Years of Process Experience' },
  { icon: '🪪', value: '1200+', label: 'Permanent Aadhar Center' },
  { icon: '👥', value: '1500+', label: 'Resource strength' },
];

const team = [

  { name: 'Mr. Vinay Pal Jain', role: 'Director', img: '/images/jain.gif'   },
  { name: 'Mr. Vikram Gupta',   role: 'CEO',       img: '/images/vikram.gif' },
];

/* Helper: get initials from name e.g. "Mr. Vinod Bansal" → "VB" */
function getInitials(name) {
  return name
    .split(' ')
    .filter(w => w.length > 2 && w !== 'Mr.' && w !== 'Mrs.' && w !== 'Ms.')
    .map(w => w[0].toUpperCase())
    .slice(0, 2)
    .join('');
}

export default function Home() {
  const [current, setCurrent] = useState(0);
  const leftRefs  = useRef([]);
  const rightRefs = useRef([]);

  useEffect(() => {
    const t = setInterval(() => setCurrent(c => (c + 1) % slides.length), 5000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const allItems = [
      ...leftRefs.current.filter(Boolean),
      ...rightRefs.current.filter(Boolean),
    ];
    const observer = new IntersectionObserver(
      entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      }),
      { threshold: 0.15 }
    );
    allItems.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* ── HERO SLIDER ── */}
      <section className="hero-section">
        <div className="hero-slides">
          {slides.map((s, i) => (
            <div
              key={i}
              className={`hero-slide${i === current ? ' active' : ''}`}
              style={{ backgroundImage: `url(${s.src})` }}
            />
          ))}
        </div>
        {/* Dark overlay for text readability */}
        <div className="hero-overlay" />

        <div className="hero-content">
          <div className="hero-logo-badge">
            <img
              src="/images/LevanteLogo2.jpg"
              alt="Matrix Processing House"
            />
          </div>
          <h1 className="hero-title">Welcome To Matrix Processing House</h1>
        </div>

        <div className="hero-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`hero-dot${i === current ? ' active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
        <button className="hero-arrow hero-arrow-prev" onClick={() => setCurrent(c => (c - 1 + slides.length) % slides.length)}>
          &#8249;
        </button>
        <button className="hero-arrow hero-arrow-next" onClick={() => setCurrent(c => (c + 1) % slides.length)}>
          &#8250;
        </button>
      </section>

      {/* ── TAGLINE ── */}
      <section className="tg_line">
        <div className="container">
          <div className="tg-hd">
            We develop <strong>Software.</strong>&nbsp;&nbsp;We build <strong>Solutions.</strong>
          </div>
        </div>
      </section>

      {/* ── WHAT WE DO ── */}
      <section className="we_do">
        <div className="container">
          <h2 className="main-heading">What <span>We Do?</span></h2>
          <div className="we-lr-sec">
            {/* LEFT */}
            <div className="left-sec">
              {leftServices.map((s, i) => (
                <div className="col" key={i} ref={el => leftRefs.current[i] = el}>
                  <div className="txt-bx-lft">
                    <h2>{s.title}</h2>
                    <p>{s.desc}</p>
                  </div>
                  <div className="icon-bx-rgt">
                    <div className="icon-bg">{s.icon}</div>
                  </div>
                </div>
              ))}
            </div>
            {/* RIGHT */}
            <div className="right-sec">
              {rightServices.map((s, i) => (
                <div className="col" key={i} ref={el => rightRefs.current[i] = el}>
                  <div className="icon-bx-rgt">
                    <div className="icon-bg">{s.icon}</div>
                  </div>
                  <div className="txt-bx-lft">
                    <h2>{s.title}</h2>
                    <p>{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── TECHNOLOGY STACK — infinite right-to-left marquee ── */}
      <section className="tech-stack-section">
        <div className="container">
          <h2 className="main-heading tech-stack-heading">Our <span>Technology Stack</span></h2>
          <p className="tech-stack-sub">Getting Wider and Stronger</p>
        </div>
        <div className="marquee-wrapper">
          <div className="marquee-track">
            {[...techStack, ...techStack].map((logo, i) => (
              <div className="marquee-item" key={i}>
                <img
                  src={logo.src}
                  alt={logo.alt}
                  onError={e => {
                    /* If image fails, show the brand name as text */
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.nextElementSibling.style.display = 'flex';
                  }}
                />
                <span className="marquee-fallback">{logo.alt}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FACTS ── */}
      <section className="hm_fact">
        <div className="container">
          <h2>Some Facts <span>About Matrix Processing House</span></h2>
          <div className="fact-abut">
            {facts.map((f, i) => (
              <div className="fact-bx" key={i}>
                <div className="fact-icon">{f.icon}</div>
                <div className="bdr-btm-fact" />
                <h2>{f.value}</h2>
                <p>{f.label}</p>
              </div>
            ))}
          </div>
          <div className="more-facts">
            <Link to="/about"><span>View More</span></Link>
          </div>
        </div>
      </section>

      {/* ── 360 SUPPORT ── */}
      <section className="home-support" style={{ backgroundImage: "url('/images/Supports.jpg')" }}>
        <div className="home-support-overlay" />
        <div className="support-bx">
          <h2>360 support</h2>
          <p>
            Matrix leverages its strong IT infrastructure to provide totally automated and
            customised business solutions which blends very effectively with clients's existing
            work processes
          </p>
          <div className="support-value">
            <div className="value-bx">
              <div className="value-icon"><span className="value-icon-label">4h</span></div>
              <p>response time for<br />ticket pre-screening</p>
            </div>
            <div className="value-bx">
              <div className="value-icon"><span className="value-icon-label">16h</span></div>
              <p>response time for<br />issue escalation</p>
            </div>
            <div className="value-bx">
              <div className="value-icon"><span className="value-icon-label">24h</span></div>
              <p>response time<br />for tickets</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── MANAGEMENT TEAM ── */}
      <section className="management-team">
        <div className="container">
          <h2>Management <span>Team</span></h2>
          <div className="team-grid">
            {team.map((m, i) => (
              <div className="team-card" key={i}>
                <div className="team-avatar">
                  <img
                    src={m.img}
                    alt={m.name}
                    onError={e => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.nextElementSibling.style.display = 'flex';
                    }}
                  />
                  <div className="team-initials">{getInitials(m.name)}</div>
                </div>
                <div className="role">{m.role}</div>
                <div className="name">{m.name}</div>
              </div>
            ))}
          </div>
          <div className="mgmt-viewmore">
            <Link to="/management-team"><span>View More</span></Link>
          </div>
        </div>
      </section>
    </>
  );
}
